import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { LoadPools, PoolsState } from '@new/pools/state/pools';
import { Store } from '@ngxs/store';

@Injectable({ providedIn: 'root' })
export class PoolsGuard implements CanActivate {
  constructor(private store: Store) {}

  public canActivate(): boolean {
    const requestState = this.store.selectSnapshot(
      PoolsState.pools
    ).requestState;

    if (requestState === 'loading' || requestState === 'success') return true;

    this.store.dispatch(new LoadPools());

    return true;
  }
}
